<template>
  <div class="row row-overflow-hidden timeline-pane">
      <div class="timeline-container">
        <ul :class="`timeline-custome timeline-visit col-md-2 col-sm-4 col-xs-4 ${visit && visit.visit_status=='accepted'?'':'disabled-process'}`">
          <li class="timeline-yellow">
            <div class="timeline-item">
              <div class="timeline-icon-container">
                <svg v-if="visit && visit.visit_status=='accepted'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.0833 2 14.1083 2.15833 15.075 2.475C16.0417 2.79167 16.9333 3.23333 17.75 3.8L16.3 5.275C15.6667 4.875 14.9917 4.56233 14.275 4.337C13.5583 4.11233 12.8 4 12 4C9.78333 4 7.896 4.779 6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 14.2167 4.77933 16.1043 6.338 17.663C7.896 19.221 9.78333 20 12 20C14.2167 20 16.1043 19.221 17.663 17.663C19.221 16.1043 20 14.2167 20 12C20 11.7 19.9833 11.4 19.95 11.1C19.9167 10.8 19.8667 10.5083 19.8 10.225L21.425 8.6C21.6083 9.13333 21.75 9.68333 21.85 10.25C21.95 10.8167 22 11.4 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM10.6 16.6L6.35 12.35L7.75 10.95L10.6 13.8L20.6 3.775L22 5.175L10.6 16.6Z" fill="#2E4051"/>
                </svg>
                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.0833 0 12.1083 0.158333 13.075 0.475C14.0417 0.791667 14.9333 1.23333 15.75 1.8L14.3 3.275C13.6667 2.875 12.9917 2.56233 12.275 2.337C11.5583 2.11233 10.8 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 9.7 17.9833 9.4 17.95 9.1C17.9167 8.8 17.8667 8.50833 17.8 8.225L19.425 6.6C19.6083 7.13333 19.75 7.68333 19.85 8.25C19.95 8.81667 20 9.4 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM8.6 14.6L4.35 10.35L5.75 8.95L8.6 11.8L18.6 1.775L20 3.175L8.6 14.6Z" fill="gray"/>
                </svg>
              </div>
              <div class="timeline-status">
                <span >Accepted</span>
              </div>
              <div class="timeline-details" >
                <div class="timeline-time" v-if="(visit||{}).visit_status=='accepted' && (visit||{}).accepted_at">
                  <span>{{ visit.accepted_at }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>

    <ul :class="`timeline-custome timeline-visit col-md-2 col-sm-4 col-xs-4 ${onTheWay.length==0?'disabled-process':''}`"  v-if="!isVirtual">
              <li class="timeline-yellow">
                  <div class="timeline-item">
                      <div class="timeline-icon-container">
                          <svg v-if="onTheWay.length" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.5833 2 14.6083 2.15833 15.575 2.475C16.5417 2.79167 17.4333 3.23333 18.25 3.8L16.8 5.275C16.1667 4.875 15.4917 4.56233 14.775 4.337C14.0583 4.11233 13.3 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 11.7 20.4833 11.4 20.45 11.1C20.4167 10.8 20.3667 10.5083 20.3 10.225L21.925 8.6C22.1083 9.13333 22.25 9.68333 22.35 10.25C22.45 10.8167 22.5 11.4 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22ZM11.1 16.6L6.85 12.35L8.25 10.95L11.1 13.8L21.1 3.775L22.5 5.175L11.1 16.6Z" fill="#2E4051"/>
                          </svg>
                          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.0833 0 12.1083 0.158333 13.075 0.475C14.0417 0.791667 14.9333 1.23333 15.75 1.8L14.3 3.275C13.6667 2.875 12.9917 2.56233 12.275 2.337C11.5583 2.11233 10.8 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 9.7 17.9833 9.4 17.95 9.1C17.9167 8.8 17.8667 8.50833 17.8 8.225L19.425 6.6C19.6083 7.13333 19.75 7.68333 19.85 8.25C19.95 8.81667 20 9.4 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM8.6 14.6L4.35 10.35L5.75 8.95L8.6 11.8L18.6 1.775L20 3.175L8.6 14.6Z" fill="gray"/>
                          </svg>
                      </div>
                      <div class="timeline-status">
                          <span>On the way</span>
                          <span style="display: block;font-size: 14px;" v-if="onTheWay.length && isRunningLate"><i v-if="onTheWay.length && isRunningLate && !isVirtual" class="fa fa-warning red"></i> Running late</span>

                      </div>
                      <div class="timeline-details" >
                        <div class="timeline-time" v-if="onTheWay.length">
                          <span>ETA {{ onTheWay[0].estimatedTimeToArrive }}</span>
                        </div>
<!--                          <div class="timeline-display-name">-->
<!--                              <h5>{{ record.displayName }}</h5>-->
<!--                          </div>-->

                      </div>
                  </div>
              </li>
          </ul>
    <ul :class="`timeline-custome timeline-visit col-md-2 col-sm-4 col-xs-4 ${arrived.length==0?'disabled-process':''}`" v-if="!isVirtual">
              <li class="timeline-yellow">
                  <div class="timeline-item">
                      <div class="timeline-icon-container">
                          <svg v-if="arrived.length" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.5833 2 14.6083 2.15833 15.575 2.475C16.5417 2.79167 17.4333 3.23333 18.25 3.8L16.8 5.275C16.1667 4.875 15.4917 4.56233 14.775 4.337C14.0583 4.11233 13.3 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 11.7 20.4833 11.4 20.45 11.1C20.4167 10.8 20.3667 10.5083 20.3 10.225L21.925 8.6C22.1083 9.13333 22.25 9.68333 22.35 10.25C22.45 10.8167 22.5 11.4 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22ZM11.1 16.6L6.85 12.35L8.25 10.95L11.1 13.8L21.1 3.775L22.5 5.175L11.1 16.6Z" fill="#2E4051"/>
                          </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.0833 0 12.1083 0.158333 13.075 0.475C14.0417 0.791667 14.9333 1.23333 15.75 1.8L14.3 3.275C13.6667 2.875 12.9917 2.56233 12.275 2.337C11.5583 2.11233 10.8 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 9.7 17.9833 9.4 17.95 9.1C17.9167 8.8 17.8667 8.50833 17.8 8.225L19.425 6.6C19.6083 7.13333 19.75 7.68333 19.85 8.25C19.95 8.81667 20 9.4 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM8.6 14.6L4.35 10.35L5.75 8.95L8.6 11.8L18.6 1.775L20 3.175L8.6 14.6Z" fill="gray"/>
                        </svg>
                      </div>
                      <div class="timeline-status">
                          <span>Arrived</span>
                      </div>
                      <div class="timeline-details" v-if="arrived.length">
<!--                          <div class="timeline-display-name">-->
<!--                              <h5>{{ record.displayName }}</h5>-->
<!--                          </div>-->
                          <div class="timeline-time">
                              <span>{{ arrived[0].arrivedTime }}</span>
                          </div>
                          <div class="timeline-time on-the-way-distance-" id="on-the-way-distance-"><!--  -->
                              <span> Travelled: {{ arrived[0].arrivedDistance }}</span>
                          </div>
                      </div>
                  </div>
              </li>
          </ul>
          <ul :class="`timeline-custome timeline-visit col-md-2 col-sm-4 col-xs-4 ${checkin.length==0?'disabled-process':''}`" v-if="!isVirtual">
              <li class="timeline-yellow">
                  <div class="timeline-item">
                      <div class="timeline-icon-container">
                          <svg v-if="checkin.length" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.5833 2 14.6083 2.15833 15.575 2.475C16.5417 2.79167 17.4333 3.23333 18.25 3.8L16.8 5.275C16.1667 4.875 15.4917 4.56233 14.775 4.337C14.0583 4.11233 13.3 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 11.7 20.4833 11.4 20.45 11.1C20.4167 10.8 20.3667 10.5083 20.3 10.225L21.925 8.6C22.1083 9.13333 22.25 9.68333 22.35 10.25C22.45 10.8167 22.5 11.4 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22ZM11.1 16.6L6.85 12.35L8.25 10.95L11.1 13.8L21.1 3.775L22.5 5.175L11.1 16.6Z" fill="#2E4051"/>
                          </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.0833 0 12.1083 0.158333 13.075 0.475C14.0417 0.791667 14.9333 1.23333 15.75 1.8L14.3 3.275C13.6667 2.875 12.9917 2.56233 12.275 2.337C11.5583 2.11233 10.8 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 9.7 17.9833 9.4 17.95 9.1C17.9167 8.8 17.8667 8.50833 17.8 8.225L19.425 6.6C19.6083 7.13333 19.75 7.68333 19.85 8.25C19.95 8.81667 20 9.4 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM8.6 14.6L4.35 10.35L5.75 8.95L8.6 11.8L18.6 1.775L20 3.175L8.6 14.6Z" fill="gray"/>
                        </svg>
                      </div>
                      <div class="timeline-status">
                          <span>Started</span>
                      </div>
                      <div class="timeline-details" v-if="checkin.length">
<!--                          <div class="timeline-display-name">-->
<!--                              <h5>{{ record.displayName }}</h5>-->
<!--                          </div>-->
                          <div class="timeline-time">
                              <span>Check In: {{ checkin[0].checkinTime }}</span>
                          </div>
                          <div class="timeline-time" v-if="checkin[0].estimatedTimeToFinish" v-show="!checkout.length">
                            <span> ETC
                            <!--                          {{ record.displayName }}-->
                            {{ checkin[0].estimatedTimeToFinish }} </span>
                          </div>
                      </div>
                  </div>
              </li>
          </ul>
          <ul class=" timeline-custome timeline-visit col-md-2 col-sm-4 col-xs-4" v-if="hasAutoCheckout">
              <li class="timeline-yellow">
                  <div class="timeline-item">
                      <div class="timeline-icon-container">
                          <svg v-if="hasAutoCheckout" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.5833 2 14.6083 2.15833 15.575 2.475C16.5417 2.79167 17.4333 3.23333 18.25 3.8L16.8 5.275C16.1667 4.875 15.4917 4.56233 14.775 4.337C14.0583 4.11233 13.3 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 11.7 20.4833 11.4 20.45 11.1C20.4167 10.8 20.3667 10.5083 20.3 10.225L21.925 8.6C22.1083 9.13333 22.25 9.68333 22.35 10.25C22.45 10.8167 22.5 11.4 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22ZM11.1 16.6L6.85 12.35L8.25 10.95L11.1 13.8L21.1 3.775L22.5 5.175L11.1 16.6Z" fill="#2E4051"/>
                          </svg>
                      </div>
                      <div class="timeline-status">
                          <span>Auto check out</span>
                      </div>
                      <div class="timeline-time timeline-details"  v-if="hasAutoCheckout">
                          <div class="timeline-display-name">
                              <span>{{ autoCheckOut[0].autoCheckout }}</span>
                          </div>
                      </div>
                  </div>
              </li>
          </ul>

          <ul :class="`timeline-custome timeline-visit col-md-2 col-sm-4 col-xs-4 ${checkout.length==0?'disabled-process':''}`">
              <li class="timeline-yellow">
                  <div class="timeline-item">
                      <div class="timeline-icon-container">
                          <svg v-if="checkout.length" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.5833 2 14.6083 2.15833 15.575 2.475C16.5417 2.79167 17.4333 3.23333 18.25 3.8L16.8 5.275C16.1667 4.875 15.4917 4.56233 14.775 4.337C14.0583 4.11233 13.3 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 11.7 20.4833 11.4 20.45 11.1C20.4167 10.8 20.3667 10.5083 20.3 10.225L21.925 8.6C22.1083 9.13333 22.25 9.68333 22.35 10.25C22.45 10.8167 22.5 11.4 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22ZM11.1 16.6L6.85 12.35L8.25 10.95L11.1 13.8L21.1 3.775L22.5 5.175L11.1 16.6Z" fill="#2E4051"/>
                          </svg>
                          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.0833 0 12.1083 0.158333 13.075 0.475C14.0417 0.791667 14.9333 1.23333 15.75 1.8L14.3 3.275C13.6667 2.875 12.9917 2.56233 12.275 2.337C11.5583 2.11233 10.8 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 9.7 17.9833 9.4 17.95 9.1C17.9167 8.8 17.8667 8.50833 17.8 8.225L19.425 6.6C19.6083 7.13333 19.75 7.68333 19.85 8.25C19.95 8.81667 20 9.4 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM8.6 14.6L4.35 10.35L5.75 8.95L8.6 11.8L18.6 1.775L20 3.175L8.6 14.6Z" fill="gray"/>
                          </svg>
                      </div>
                      <div class="timeline-status">
                          <span>Finished</span>
                      </div>
                      <div class="timeline-details" v-if="checkout.length">

<!--                          <div class="timeline-display-name">-->
<!--                              <h5>{{ record.displayName }}</h5>-->
<!--                          </div>-->
                          <div class="timeline-time">
                              <span>{{ checkout[0].checkoutTime }}</span>
                          </div>
                        <div class="timeline-time after-main" v-show="!checkout.length">
                          <b> ETC {{ checkout[0].displayName }}
                            {{ checkout[0].estimatedTimeToFinish }} </b>
                        </div>
                          <div class="on-the-way-distance-" v-show="checkout[0].visitDistanceInt > 0" id="check-out-distance-">
                              <h5>travelled: {{ checkout[0].visitDistance }}</h5>
                          </div>
                      </div>
                  </div>
              </li>
          </ul>

      </div>
  </div>
</template>

<script>

import {getVisitDetails} from "@/modules/Booking/api/visits"

export default {
  name: "BookingViewScheduledVisitTimeline",
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
      required: false
    },
    fieldworkerVisitStatus:{
      type: Object,
      default() {
        return {}
      },
    },
    bookingId: {
      type: Number,
      default: null,
      required: false
    },
    visitBreakDownIds: {
      type: Array,
      default: null,
      required: false
    },
    isRunningLate: {
      type: Boolean,
      default: false,
    }
    ,
  isVirtual: {
      type: Boolean,
      default: false,
    },
    visit: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      multipleDays: this.value
    }
  },
  computed: {
    instances() {
      return this.multipleDays
    },
    onTheWay() {
      let contractors = [];
      if (this.instances.length > 0) {
        for (let instance of this.instances) {
          if (instance.onTheWayTime) {
            contractors.push({
              onTheWayDistance: instance.onTheWayDistance,
              onTheWayLocation: instance.onTheWayLocation,
              onTheWayTime: instance.onTheWayTime,
              displayName: instance.displayName,
              estimatedTimeToArrive: instance.estimatedTimeToArrive,
              timestamps: instance.timestamps,
              visitId: instance.visitId
            })
          }
        }
      }
      return contractors;
    },
    arrived() {
      let contractors = [];
      if (this.instances.length > 0) {
        for (let instance of this.instances) {
          if (instance.arrivedTime) {
            contractors.push({
              arrivedTime: instance.arrivedTime,
              displayName: instance.displayName,
              arrivedDistance: instance.onTheWayDistance,
              timestamps: instance.timestamps,
              visitId: instance.visitId
            })
          }
        }
      }
      return contractors;
    },
    checkin() {
      let contractors = [];
      if (this.instances.length > 0) {
        for (let instance of this.instances) {
          if (instance.checkinDate) {
            contractors.push({
              checkinTime: instance.checkinTime,
              displayName: instance.displayName,
              timestamps: instance.timestamps,
              estimatedTimeToFinish: instance.estimatedTimeToFinish,
              visitId: instance.visitId
            })
          }
        }
      }
      return contractors;
    },
    checkout() {
      let contractors = [];
      if (this.instances.length > 0) {
        for (let instance of this.instances) {
          if (instance.checkoutDate) {
            contractors.push({
              checkoutDate: instance.checkoutDate,
              checkoutTime: instance.checkoutTime,
              displayName: instance.displayName,
              visitDistance: instance.visitDistance,
              visitDistanceInt: parseFloat(instance.visitDistance),
              estimatedTimeToFinish: instance.estimatedTimeToFinish,
              timestamps: instance.timestamps,
              visitId: instance.visitId
            })
          }
        }
      }
      return contractors;
    },
    hasAutoCheckout() {
      return this.autoCheckOut.filter(instance => instance.isAutoCheckout).length > 0
    },
    autoCheckOut() {
      let contractors = [];
      if (this.instances.length > 0) {
        for (let instance of this.instances) {
          if (instance.isAutoCheckout) {
            contractors.push({
              isAutoCheckout: instance.isAutoCheckout,
              autoCheckout: instance.autoCheckout,
              displayName: instance.displayName,
              timestamps: instance.timestamps
            })
          }
        }
      }
      return contractors;
    },
  },
  mounted() {


  }
}
</script>

<style scoped>
.after-main {
  font-size: 11px !important;
}
.timeline-container {
    display: flex; /* Use flexbox to align children in a row */
    flex-wrap: wrap; /* Allows items to wrap to next line if not enough space */
    justify-content: space-around; /* Adjust this as per your layout needs */
    align-items: center; /* Align items vertically */
    font-weight: 400;
    font-size: 16px;
  color: #2E4051;
}
.timeline-visit{
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}
.disabled-process{
  color: gray;
}

.timeline-pane{
  width: 100%
}
.timeline-details h5,.timeline-details .after-main{
  width: 100%
}
.timeline-item{
  min-height: 130px;
}
.timeline-time{
  font-size: small;
}
@media (max-width: 768px) {
  .timeline-item{
    min-height: auto;
  }
  .timeline-container {
    display: table;
    width: 100%;
  }
  .timeline-container .timeline-visit:nth-child(4){
    margin-left: 1px;
  }
}
</style>